import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import {
  VAULTURE_USERID_KEY,
  VAULTURE_USER_AVATAR_KEY,
} from '../../utils/constants'

interface Props {
  location: any
}

class Logout extends Component<Props> {
  constructor(props: any) {
    super(props)
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')

    localStorage.removeItem(VAULTURE_USERID_KEY)
    localStorage.removeItem(VAULTURE_USER_AVATAR_KEY)
  }

  render() {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: this.props.location },
        }}
      />
    )
  }
}

export default Logout
